module.exports = __webpack_public_path__ + "static/media/paw.a67c80c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DogCard/paw.svg
// module id = 310
// module chunks = 0